import { render } from "./AcceptTermsModal.vue?vue&type=template&id=2576ec8e&scoped=true"
import script from "./AcceptTermsModal.vue?vue&type=script&lang=js"
export * from "./AcceptTermsModal.vue?vue&type=script&lang=js"

import "./AcceptTermsModal.vue?vue&type=style&index=0&id=2576ec8e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2576ec8e"]])

export default __exports__